<template>
  <div class="dataset-foot">

    <slot
      name="load-more"
      :onClick="onLoadMore"
    >
      <control-button
        class="is-small has-icons-right"
        button-style="5"
        @click="onLoadMore"
        v-if="gotAllData === false"
      >
        <!-- <template >
          <span>Out of data</span>
        </template> -->
        <template>
          <span>Load more</span>
          <span class="icon is-small">
            <i
              class="loader"
              v-if="loadingMore"
            ></i>
            <decor-icon
              icon="chevron-down"
              v-else
            ></decor-icon>
          </span>
        </template>
      </control-button>

      <control-button
        class="is-small has-icons-right has-margin-left-small"
        button-style="5"
        @click="onClearMeta"
        v-if="allowClearMeta"
      >
        <slot name="btnClearMetaLabel" />
      </control-button>

    </slot>

  </div>
</template>

<script>
export default {
  name: 'DatasetFooter',
  props: {
    dataset: { type: Object, default: () => null },
    allowClearMeta: { type: Boolean, default: () => false },
  },
  computed: {
    loadingMore() {
      return this.dataset.loadingMore
    },
    meta() {
      return this.dataset.meta
    },
    gotAllData() {
      return this.dataset.gotAllData
    },
  },
  methods: {
    // load more content event
    onLoadMore() {
      return this.dataset.loadmore()
    },
    onClearMeta() {
      return this.dataset.clearMeta()
    },
  },
}
</script>

<style lang="scss">
.dataset-foot {
  padding: 1.5em;
}
</style>
